import React, { useState } from 'react'

import { Autocomplete } from '@react-google-maps/api';
import  AppBar from '@material-ui/core/AppBar';
import  Toolbar from '@material-ui/core/Toolbar';
import  Typography from '@material-ui/core/Typography';
import  InputBase from '@material-ui/core/InputBase';
import  Box from '@material-ui/core/Box';
import SearchIcon from '@material-ui/icons/Search';

import useStyles from './headerStyle';


const Header=({setCoordinates})=> {
    const classes = useStyles();
    const [autoComplete, setAutoComplete] = useState(null);

    const onLoad = (autoComp) => setAutoComplete(autoComp);

    const onPlaceChanged = () =>{
        const lat = autoComplete.getPlace().geometry.location.lat();
        const lng = autoComplete.getPlace().geometry.location.lng();
        // const lat = autoComplete.getPlace().geometry.location.lat();
        // const lng = autoComplete.getPlace().geometry.location.lng();
        setCoordinates({lat,lng});
      
    }

    return (
        <AppBar position="static">
            <Toolbar className={classes.toolbar}>
                <Typography variant="h5" className={classes.title}>
                    Travel Advisor
                </Typography>
                <Box display="flex">
                    <Typography variant="h6" className={classes.title}>
                         Explore new places
                    </Typography>
                    <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
                    <div className={classes.search}>
                        <div className={classes.searchIcon}>
                           <SearchIcon />
                        </div>
                        <InputBase placeholder="Search..." classes={{ root: classes.inputRoot, input: classes.inputInput }} />
                    </div>
                 
                    </Autocomplete>
                </Box>
            </Toolbar>
        </AppBar>
        
    )
}

export default Header



